import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from "@mui/styles";
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, TablePagination, Collapse, Select, MenuItem, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { bagweigherUserTableColumns } from '../../../Config/constants';
import BagweigherUserDialog from '../../Shared/Dialogs/User/BagweigherUserDialog';

import ScanBadgeDialog from '../../Shared/Dialogs/ScanBadgeDialog';

import { Spin } from "react-cssfx-loading";
import { connect } from 'react-redux';
import { Check, EllipsisVertical, Search, X, ChevronUp, ChevronDown } from 'lucide-react';

export const BagweigherUsersOverviewTable = (props) => {
    const classes = useStyles();

    const [selectedUser, setSelectedUser] = useState(null);
    const [editingUser, setEditingUser] = useState(false);
    const [scanningBadge, setScanningBadge] = useState(false);

    const { t } = useTranslation();
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(25);
    const [dropdownItem, setDropdownItem] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [localUsers, setLocalUsers] = useState([]);
    const [filterValues, setFilterValues] = useState([
        { type: bagweigherUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.FUNCTION, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.ISACTIVE, value: "", groupingUp: false, groupingDown: false },
        { type: bagweigherUserTableColumns.RECEIVEMAILS, value: "", groupingUp: false, groupingDown: false },
    ]);

    const dropdownRef = useRef(null);

    useEffect(() => {
        console.log(props.users)
        if (localUsers.length === 0) {
            let tempUsers = props.users.map(x => ({
                ...x,
                visible: true
            }));
            setLocalUsers(tempUsers);
            setFilteredUsers(tempUsers);
        } else if (props.users.length > localUsers.length) {
            let tempUsers = [...localUsers];
            let newUsers = props.users[props.users.length - 1];
            newUsers.visible = true;
            tempUsers.push(newUsers);
            setLocalUsers(tempUsers);
            filterAndGroupUsers(filterValues, tempUsers);
        }
    }, [props.users]);

    useEffect(() => {
        if (!props.showFilters) {
            handleRemoveFilters();
        }
    }, [props.showFilters]);

    const handleUserUpdate = (user) => {
        user.visible = true;
        let tempUsers = [...localUsers];
        let index = tempUsers.findIndex(x => x.Id === user.Id);
        tempUsers[index] = user;
        setLocalUsers(tempUsers);
        filterAndGroupUsers(filterValues, tempUsers);
        props.updateBagweigherUserLocally(user);
    }

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value));
        setpg(0);
    }

    const handleToggleDropdown = (id) => {
        if (dropdownItem) {
            setDropdownItem(null);
            return;
        }
        setDropdownItem(id);

    }

    const handleClickOutsideDropdown = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setTimeout(() => {
                setDropdownItem(null);
            }, 100);
        }
    };

    useEffect(() => {
        if (dropdownItem) {
            document.addEventListener('mousedown', handleClickOutsideDropdown);
        } else {
            document.removeEventListener('mousedown', handleClickOutsideDropdown);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutsideDropdown);
        };
    }, [dropdownItem]);

    const formatDate = (date) => {
        let d = new Date(date);

        let optionsDate = { day: '2-digit', month: '2-digit', year: 'numeric' };
        let optionsTime = { hour: '2-digit', minute: '2-digit' };

        let dateString = d.toLocaleDateString('en-GB', optionsDate).replace(/\//g, '-');
        let timeString = d.toLocaleTimeString('en-GB', optionsTime);

        return dateString + " (" + timeString + ")";
    }

    const formatBoolean = (value) => {
        if (value) {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <Check size={20} color="#5CC958"></Check>
                    <p style={{ margin: "0", color: "#5CC958" }}>{t("Badge assigned")}</p>
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <X size={20} color="#D84949"></X>
                    <p style={{ margin: "0", color: "#D84949" }}>{t("No badge assigned")}</p>
                </div>
            )
        }
    }

    const formatIsActive = (active) => {
        if (active) {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "3px", backgroundColor: "#5CC958" }} />
                    <p style={{ margin: "0px" }}>{t("Active")}</p>
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "3px", backgroundColor: "#D84949" }} />
                    <p style={{ margin: "0px" }}>{t("Inactive")}</p>
                </div>
            )
        }
    }

    const formatReceiveMail = (active) => {
        if (active) {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "3px", backgroundColor: "#5CC958" }} />
                    <p style={{ margin: "0px" }}>{t("Yes")}</p>
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "3px", backgroundColor: "#D84949" }} />
                    <p style={{ margin: "0px" }}>{t("No")}</p>
                </div>
            )
        }
    }

    const formatFunction = (isAdmin) => {
        if (isAdmin) {
            return (
                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#FBE5E5", color: "#D84949", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                    Admin
                </div>
            );
        } else {
            return (
                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                    Operator
                </div>
            );
        }
    }

    const getGroupingIconColor = (type, up) => {
        if (filterValues.some(x => x.type === type)) {
            if (up) {
                if (filterValues.find(x => x.type === type).groupingUp) {
                    return "#4654FB";
                }
            }
            else {
                if (filterValues.find(x => x.type === type).groupingDown) {
                    return "#4654FB";
                }
            }
        }
        return "rgba(12, 14, 41, .6)";
    }

    const getGroupingIconSize = (type, up) => {
        if (filterValues.some(x => x.type === type)) {
            if (up) {
                if (filterValues.find(x => x.type === type).groupingUp) {
                    return 16;
                }
            }
            else {
                if (filterValues.find(x => x.type === type).groupingDown) {
                    return 16;
                }
            }
        }
        return 12;
    }

    const searchScannedBadge = (badgeNumber) => {
        handleSearch(badgeNumber, bagweigherUserTableColumns.BADGENUMBER);
    };

    const handleRemoveFilters = () => {
        let tempUsers = props.users.map(x => ({
            ...x,
            visible: true
        }));

        setFilterValues([
            { type: bagweigherUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.FUNCTION, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.ISACTIVE, value: "", groupingUp: false, groupingDown: false },
            { type: bagweigherUserTableColumns.RECEIVEMAILS, value: "", groupingUp: false, groupingDown: false }
        ])

        setFilteredUsers(tempUsers);
    }

    const clearFilter = (column) => {
        let tempFilterValues = [...filterValues];

        tempFilterValues.find(x => x.type === column).value = "";

        let filterPresent = false;

        tempFilterValues.map(filterValue => {
            if (filterValue.value && filterValue.value.toString() !== null && (filterValue.value.length > 0 || filterValue.value == true)) {
                filterPresent = true;
            }
        })

        if (!filterPresent) {
            tempFilterValues = [
                { type: bagweigherUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.FUNCTION, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.ISACTIVE, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.RECEIVEMAILS, value: "", groupingUp: false, groupingDown: false }
            ]
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const handleSearch = (e, column) => {
        let value;

        value = e.target.value

        let tempFilterValues = [...filterValues];

        if (tempFilterValues.some(x => x.type === column)) {
            tempFilterValues.find(x => x.type === column).value = value;
        } else {
            tempFilterValues.push({ type: column, value: value });
        }

        let filterPresent = false;

        tempFilterValues.map(filterValue => {
            if (filterValue.value && filterValue.value.toString() !== null && (filterValue.value.length > 0 || filterValue.value == true)) {
                filterPresent = true;
            }
        })

        if (!filterPresent) {
            tempFilterValues = [
                { type: bagweigherUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.FUNCTION, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.ISACTIVE, value: "", groupingUp: false, groupingDown: false },
                { type: bagweigherUserTableColumns.RECEIVEMAILS, value: "", groupingUp: false, groupingDown: false }
            ]
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const handleGrouping = (column, up) => {
        let tempFilterValues = [...filterValues];

        if (tempFilterValues.some(x => x.type === column)) {
            if (up) {
                // Check if already grouped up
                if (tempFilterValues.find(x => x.type === column).groupingUp) {
                    // Remove grouping if already grouped up
                    tempFilterValues.find(x => x.type === column).groupingUp = false;
                } else {
                    // Group up
                    tempFilterValues.find(x => x.type === column).groupingUp = true;
                    tempFilterValues.find(x => x.type === column).groupingDown = false;
                }
            } else {
                // Check if already grouped up
                if (tempFilterValues.find(x => x.type === column).groupingDown) {
                    // Remove grouping if already grouped down
                    tempFilterValues.find(x => x.type === column).groupingDown = false;
                } else {
                    // Group down
                    tempFilterValues.find(x => x.type === column).groupingDown = true;
                    tempFilterValues.find(x => x.type === column).groupingUp = false
                }
            }
        } else {
            tempFilterValues.push({ type: column, value: "", groupingUp: up, groupingDown: !up });
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const filterAndGroupUsers = (filterValues, userCollection) => {
        let tempUsers;
        if (userCollection) {
            tempUsers = JSON.parse(JSON.stringify(userCollection));
        } else {
            tempUsers = JSON.parse(JSON.stringify(localUsers));
        }

        filterValues.forEach(filterValue => {
            var value = filterValues.find(x => x.type === filterValue.type).value;
            switch (filterValue.type) {
                case bagweigherUserTableColumns.ID:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Id) { if (!x.Id.toLowerCase().includes(value.toLowerCase())) { x.visible = false } } else { x.visible = false } })
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Id < b.Id) ? 1 : -1);
                    }
                    break;
                case bagweigherUserTableColumns.NAME:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Name) { if (!x.Name.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? 1 : -1);
                    }
                    break;
                case bagweigherUserTableColumns.EMAIL:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Email) { if (!x.Email.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Email > b.Email) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Email < b.Email) ? 1 : -1);
                    }
                    break;
                case bagweigherUserTableColumns.FUNCTION:
                    if (value !== null && value !== "") {
                        if (value === "Admin") {
                            tempUsers.map(x => { if (!x.IsAdmin) { x.visible = false; } });
                        } else if (value === "Operator") {
                            tempUsers.map(x => { if (x.IsAdmin) { x.visible = false; } });
                        }
                    }
                    // if (value !== null && value !== "") {
                    //     tempUsers.map(x => {
                    //         x.Roles.map(role => {
                    //             if (role.Name && !role.Name.toString().toLowerCase().includes(value.toString().toLowerCase())) {
                    //                 x.visible = false;
                    //             }
                    //         });
                    //     });
                    // }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.IsAdmin > b.IsAdmin) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.IsAdmin < b.IsAdmin) ? 1 : -1);
                    }
                    break;
                case bagweigherUserTableColumns.BADGENUMBER:
                    if (value !== null && value !== "" && value !== undefined) {
                        if (value === "assigned") {
                            tempUsers.map(x => { if (!x.Badgenumber) { x.visible = false; } });
                        } else if (value === "notAssigned") {
                            tempUsers.map(x => { if (x.Badgenumber) { x.visible = false; } });
                        } else {
                            tempUsers.map(x => {
                                if (x.Badgenumber) {
                                    if (x.Badgenumber.toString().toLowerCase() !== value.toString().toLowerCase()) {
                                        x.visible = false;
                                    }
                                } else {
                                    x.visible = false;
                                }
                            });
                        }
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Badgenumber > b.Badgenumber) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Badgenumber < b.Badgenumber) ? 1 : -1);
                    }
                case bagweigherUserTableColumns.ISACTIVE:
                    if (value !== null && value !== "") {
                        if (value === "Active") {
                            tempUsers.map(x => { if (!x.IsActive) { x.visible = false; } });
                        } else if (value === "Inactive") {
                            tempUsers.map(x => { if (x.IsActive) { x.visible = false; } });
                        }
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.IsActive > b.IsActive) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.IsActive < b.IsActive) ? 1 : -1);
                    }
                case bagweigherUserTableColumns.RECEIVEMAILS:
                    if (value !== null && value !== "") {
                        if (value === "1") {
                            tempUsers.map(x => { if (!x.ReceiveMail) { x.visible = false; } });
                        } else if (value === "0") {
                            tempUsers.map(x => { if (x.ReceiveMail) { x.visible = false; } });
                        }
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.ReceiveMail > b.ReceiveMail) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.ReceiveMail < b.ReceiveMail) ? 1 : -1);
                    }
            }
        });
        setFilteredUsers(tempUsers);
    }

    const handleEditUser = (user) => {
        setDropdownItem(null);
        setSelectedUser(user);
        setEditingUser(true);
    }

    const closeEditDialog = () => {
        setSelectedUser(null);
        setEditingUser(false);
    }

    return (
        <React.Fragment>
            {props.loading ? <div className={classes.loadingBalls}><Spin width="100px" height="100px" color="#4654FB"></Spin></div> :
                <div className={classes.tableContainer}>
                    <React.Fragment>
                        <TableContainer className={classes.tableContainer}>
                            <Table className={classes.table} aria-label="customized table">
                                <TableHead className={classes.head}>
                                    {/* Filters */}
                                    <TableRow className={classes.head__filterRow}>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.ID].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.ID)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell} >
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.NAME].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.NAME)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.EMAIL].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.EMAIL)} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[bagweigherUserTableColumns.FUNCTION].value}
                                                    onChange={(e) => handleSearch(e, bagweigherUserTableColumns.FUNCTION)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '.MuiOutlinedInput-notchedOutline': {
                                                            border: "none",
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                            border: 'none',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        classes: { paper: classes.menu },
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">{t("All")}</MenuItem>
                                                    <MenuItem value="Admin">{t("Admin")}</MenuItem>
                                                    <MenuItem value="Operator">{t("Operator")}</MenuItem>
                                                </Select>

                                                {/* <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.FUNCTION].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.FUNCTION)} />
                                                </div> */}
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                {!["", "assigned", "notAssigned"].includes(filterValues[bagweigherUserTableColumns.BADGENUMBER].value) ?
                                                    <div className={classes.head__filterInputContainer}>
                                                        <div className={classes.head__fakeFilterInput} type="text" value={filterValues[bagweigherUserTableColumns.BADGENUMBER].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.BADGENUMBER)}>
                                                            <p>{t("Badge scanned")}</p>
                                                        </div>
                                                        <button className={classes.head__filterInputButton} onClick={() => clearFilter(bagweigherUserTableColumns.BADGENUMBER)}>
                                                            <X size={16} />
                                                        </button>
                                                    </div>
                                                    :
                                                    <Select
                                                        value={filterValues[bagweigherUserTableColumns.BADGENUMBER].value}
                                                        onChange={(e) => handleSearch(e, bagweigherUserTableColumns.BADGENUMBER)}
                                                        displayEmpty
                                                        className={classes.head__filterSelect}
                                                        sx={{
                                                            '.MuiOutlinedInput-notchedOutline': {
                                                                border: "none",
                                                            },
                                                            '& .MuiSelect-select': {
                                                                padding: 0,
                                                                border: 'none',
                                                            },
                                                        }}
                                                        MenuProps={{
                                                            classes: { paper: classes.menu },
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="">{t("All")}</MenuItem>
                                                        <MenuItem value="assigned">{t("Badge assigned")}</MenuItem>
                                                        <MenuItem value="notAssigned">{t("No badge assigned")}</MenuItem>
                                                        {/* button at bottom of dropdown "scan badge" */}
                                                        <MenuItem
                                                            className={classes.buttonItem}
                                                            disableRipple
                                                            onClick={(e) => e.preventDefault()}
                                                        >
                                                            <button
                                                                className={classes.dropdownButton}
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                onClick={() => setScanningBadge(true)}
                                                            >
                                                                {t("Scan badge")}
                                                            </button>
                                                        </MenuItem>
                                                    </Select>
                                                }
                                                {/* <div className={classes.head__filterInputContainer}>
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[metisUserTableColumns.BADGENUMBER].value} onChange={(e) => handleSearch(e, metisUserTableColumns.BADGENUMBER)} />
                                                    <Search size={16} className={classes.head__filterInputIcon} />
                                                </div> */}
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[bagweigherUserTableColumns.ISACTIVE].value}
                                                    onChange={(e) => handleSearch(e, bagweigherUserTableColumns.ISACTIVE)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '.MuiOutlinedInput-notchedOutline': {
                                                            border: "none",
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                            border: 'none',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        classes: { paper: classes.menu },
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        {t("All")}
                                                    </MenuItem>
                                                    <MenuItem value="Active">
                                                        {t("Active")}
                                                    </MenuItem>
                                                    <MenuItem value="Inactive">
                                                        {t("Inactive")}
                                                    </MenuItem>
                                                </Select>
                                                {/* <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.ISACTIVE].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.ISACTIVE)} />
                                                </div> */}
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[bagweigherUserTableColumns.RECEIVEMAILS].value}
                                                    onChange={(e) => handleSearch(e, bagweigherUserTableColumns.RECEIVEMAILS)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '.MuiOutlinedInput-notchedOutline': {
                                                            border: "none",
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                            border: 'none',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        classes: { paper: classes.menu },
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        {t("All")}
                                                    </MenuItem>
                                                    <MenuItem value="1">
                                                        {t("Yes")}
                                                    </MenuItem>
                                                    <MenuItem value="0">
                                                        {t("No")}
                                                    </MenuItem>
                                                </Select>
                                                {/* <div className={classes.head__filterInputContainer}>
                                                    <Search size={12} className={classes.head__filterInputIcon} />
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[bagweigherUserTableColumns.ISACTIVE].value} onChange={(e) => handleSearch(e, bagweigherUserTableColumns.ISACTIVE)} />
                                                </div> */}
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>

                                    {/* Headers */}
                                    <TableRow className={classes.head__headerRow}>
                                        <TableCell className={classes.head__headCell} style={{ width: '8%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("ID")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.ID, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.ID, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.ID, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.ID, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.ID, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.ID, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '16%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Name")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.NAME, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.NAME, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.NAME, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.NAME, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.NAME, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.NAME, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '24%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Email")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.EMAIL, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.EMAIL, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.EMAIL, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.EMAIL, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.EMAIL, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.EMAIL, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '16%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Function")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.FUNCTION, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.FUNCTION, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.FUNCTION, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.FUNCTION, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.FUNCTION, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.FUNCTION, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '24%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Badge number")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.BADGENUMBER, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.BADGENUMBER, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.BADGENUMBER, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.BADGENUMBER, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.BADGENUMBER, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.BADGENUMBER, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Active")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.ISACTIVE, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.ISACTIVE, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.ISACTIVE, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.ISACTIVE, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.ISACTIVE, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.ISACTIVE, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '12%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Receive email")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(bagweigherUserTableColumns.RECEIVEMAILS, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.RECEIVEMAILS, true) }} onClick={() => handleGrouping(bagweigherUserTableColumns.RECEIVEMAILS, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(bagweigherUserTableColumns.RECEIVEMAILS, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(bagweigherUserTableColumns.RECEIVEMAILS, false) }} onClick={() => handleGrouping(bagweigherUserTableColumns.RECEIVEMAILS, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '44px' }}>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                {props.users.length > 0 ?
                                    <TableBody className={classes.body}>
                                        {filteredUsers.filter(x => x.visible).slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                            <>
                                                <TableRow key={index} className={classes.body__row}>
                                                    <TableCell className={classes.body__cell}>{row.Id}</TableCell>
                                                    <TableCell className={classes.body__cell}>{row.Name}</TableCell>
                                                    <TableCell className={classes.body__cell}>{row.Email || "-"}</TableCell>
                                                    <TableCell className={classes.body__cell}>{formatFunction(row.IsAdmin)}</TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
                                                            {formatBoolean(row.Badgenumber)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
                                                            {formatIsActive(row.IsActive)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
                                                            {formatReceiveMail(row.ReceiveMail)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <button onClick={() => handleToggleDropdown(row.Id)} className={classes.body__editCellButton} style={{ backgroundColor: dropdownItem == row.Id ? "#DCDCDC" : "transparent" }}><EllipsisVertical size={20} absoluteStrokeWidth strokeWidth={1.4}></EllipsisVertical></button>
                                                    </TableCell>
                                                    {dropdownItem == row.Id ? <div ref={dropdownRef} className={classes.row__dropdown}>
                                                        <button className={classes.row__dropdownButton} onClick={() => handleEditUser(row)}>{t("Edit")}</button>
                                                    </div> : null}
                                                </TableRow>
                                            </>
                                        ))}
                                    </TableBody>
                                    : null}
                            </Table>
                        </TableContainer>
                        {filteredUsers.filter(x => x.visible).length === 0 ?
                            null
                            :
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                component="div"
                                labelRowsPerPage={t("Rows per page")}
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t("of")} ${count}`}
                                count={filteredUsers.filter(x => x.visible).length}
                                rowsPerPage={rpg}
                                page={pg}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        }
                    </React.Fragment>
                    {props.users.length > 0 ? null :
                        <div className={classes.emptyStateContainer}>
                            <p className={classes.emptyState__text}>
                                {t("No users found")}.
                            </p>
                        </div>
                    }
                    {filteredUsers.filter(x => x.visible).length === 0 ?
                        <div className={classes.emptyStateContainer}>
                            <p className={classes.emptyState__text}>{t("No users found")}.</p>
                        </div>
                        :
                        null
                    }
                </div>
            }
            {
                selectedUser && editingUser &&
                <BagweigherUserDialog selectedUser={selectedUser} editing={editingUser} updateBagweigherUserLocally={handleUserUpdate} allUsers={props.users} dialogOpen={selectedUser && editingUser} closeDialog={closeEditDialog} />
            }
            {
                scanningBadge &&
                <ScanBadgeDialog dialogOpen={scanningBadge} closeDialog={() => setScanningBadge(false)} handleBadgeNumber={searchScannedBadge} subtitle={t("Scan a badge to find the owner")} />
            }
        </React.Fragment >
    )


}

const useStyles = makeStyles({

    paper: {
        boxShadow: 'none',
        backgroundColor: 'transparent',
    },

    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'medium',
        color: "#020100",
        float: "left",
        marginBottom: "10px",
        paddingLeft: "20px",
        marginTop: "15px"
    },

    head: {

    },

    head__filterRow: {
        height: 'fit-content',
    },

    collapse: {
        float: "left",
        width: "100%",
    },

    head__filterCell: {
        padding: "0px 0px 8px 8px !important",


        "&:first-child": {
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            paddingRight: "8px !important",
        },
    },

    head__filterInputContainer: {
        position: 'relative',
    },

    head__filterInputButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '4px',
        border: 'none',
        backgroundColor: 'transparent',
        color: FlagstoneTheme.palette.text.primary,
        cursor: 'pointer',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        padding: '0px',
        width: '20px',
        height: '20px',
        borderRadius: '4px',

        transition: 'all 0.2s',

        "&:hover": {
            backgroundColor: '#F8F8F8',
            color: '#D84949',
        },
    },

    head__filterInputIcon: {
        color: FlagstoneTheme.palette.text.primary,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '6px',
    },

    head__fakeFilterInput: {
        width: '100%',
        height: '28px',
        borderRadius: '4px',
        border: 'none',

        display: 'flex',
        alignItems: 'center',

        padding: '0px 8px',
        paddingRight: '28px',
        boxSizing: 'border-box',

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: FlagstoneTheme.palette.text.primary,

        backgroundColor: "#FFFFFF",

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterInput: {
        width: '100%',
        height: '28px',
        borderRadius: '4px',
        border: 'none',



        padding: '0px 8px',
        paddingRight: '28px',
        boxSizing: 'border-box',

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: FlagstoneTheme.palette.text.primary,

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterSelect: {
        width: '100%',
        height: '28px',
        borderRadius: '4px !important',
        border: 'none !important',

        padding: '0px 8px',
        boxSizing: 'border-box !important',

        fontSize: '14px !important',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'normal !important',
        color: '#0C0E29 !important',

        backgroundColor: 'white',

        "&:focus": {
            outline: "none",
            borderColor: "#4654FB",
        },
    },

    menu: {
        backgroundColor: '#fff',
        borderRadius: "4px",
        marginTop: "8px", // Space between select box and menu
        padding: '4px',
        paddingTop: '4px !important',
        paddingBottom: '4px !important',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // Shadow for the dropdown menu

        minWidth: "148px !important",
        width: "fit-content !important",

        '& .MuiMenu-list': {
            padding: 0, // Padding inside the dropdown menu
        },

        '& .MuiMenuItem-root': {
            fontSize: "14px", // Font size for menu items
            color: FlagstoneTheme.palette.text.primary, // Text color for menu items
            padding: '8px 12px', // Padding inside each menu item
            borderRadius: '3px',
            '&:hover': {
                backgroundColor: '#F8F8F8', // Background color on hover
            },
            '&.Mui-selected': {
                backgroundColor: '#e0e0e0', // Background color when selected
                '&:hover': {
                    backgroundColor: '#d5d5d5', // Background color when selected and hovered
                },
            },
        },
    },

    buttonItem: {
        padding: '0px !important', // Adjust padding to match menu items

        '&:hover': {
            backgroundColor: 'transparent !important', // Remove hover background color
        },
    },

    dropdownButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        color: "white !important",
        fontSize: "14px !important",
        fontFamily: "Lato, sans-serif !important",
        minWidth: "100% !important",
        padding: '8px 16px !important',
        textTransform: 'capitalize !important',
        border: 'none !important',
        borderRadius: '3px',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        '&:hover': {
            cursor: 'pointer !important',
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    head__filterInput_date: {
        width: '100%',
        height: '28px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        boxSizing: 'border-box',

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__headerRow: {
        backgroundColor: '#E2E4F5',
        borderRadius: "6px",
    },

    head__headCell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "bold !important",
        color: "#0C0E29",

        padding: "8px 8px !important",
        paddingTop: "0px",
        border: "none",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "8px !important",
        },
    },

    headCell__contentContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px"
    },

    groupingArrowsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0px",
        width: "fit-content"
    },

    groupingArrowUpContainer: {
        position: "relative",
        width: "16px",
        height: "12px",

        "&:hover": {
            cursor: "pointer",

            "& $groupingArrowUp": {
                width: "16px",
                height: "16px",

                transition: "all .1s ease-in",

                color: "#4654FB"
            },
        }
    },

    groupingArrowDownContainer: {
        position: "relative",
        width: "16px",
        height: "12px",

        overflow: "hidden",

        "&:hover": {
            cursor: "pointer",

            "& $groupingArrowDown": {
                width: "16px",
                height: "16px",

                transition: "all .1s ease-in",

                color: "#4654FB"
            },
        }
    },

    groupingArrowUp: {
        position: "absolute",
        bottom: "0%",
        left: "50%",
        transform: "translate(-50%, 0%)",
    },

    groupingArrowDown: {
        position: "absolute",
        top: "0%",
        left: "50%",
        transform: "translate(-50%, 0%)",
    },

    body__row: {
        position: "relative",

        "&:nth-of-type(even)": {
            backgroundColor: "#F7F7F7",
            // mixBlendMode: "multiply",
        },
    },

    body__cell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",
        padding: "16px 8px !important",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "8px !important",
        },
    },

    body__editCellButton: {
        width: "28px",
        height: "28px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px",
        margin: "0px",
        color: FlagstoneTheme.palette.text.primary,

        transition: "background-color 0.1s",

        "&:hover": {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: FlagstoneTheme.palette.secondary.main,
        }
    },

    row__dropdown: {
        position: "absolute",
        right: "8px",
        top: "48px",

        width: "fit-content",
        height: "fit-content",

        padding: "4px",

        backgroundColor: "white",
        zIndex: "999",
        boxShadow: "0px 3px 15px rgba(175, 175, 175, 0.25)",
        borderRadius: "6px",

    },

    row__dropdownButton: {
        width: "100%",
        height: "32px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "medium",

        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",

        padding: "8px 12px",
        margin: "0px",

        color: FlagstoneTheme.palette.text.primary,

        transition: "background-color 0.1s",

        "&:hover": {
            backgroundColor: "#F8F8F8",
        }
    },

    emptyStateContainer: {
        width: '100%',

        textAlign: "center",
        marginTop: "192px",
    },

    emptyState__text: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",
    },

    tableContainer: {
        height: "auto",
        overflow: "visible",
        overflowX: "visible !important",
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    table: {
        borderSpacing: '0px 5px',
        borderCollapse: 'separate',
    },

    arrowUp: {
        width: "15px",
        marginLeft: "10px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    arrowDown: {
        width: "15px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    loadingBalls: {
        height: '100%',
        display: 'flex',
        // alignContent: 'center',
        // alignItems: 'center',
        justifyContent: 'center',
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(BagweigherUsersOverviewTable)